import { Image as ImageIcon, Video } from 'lucide-react';

import { cn } from '../../../../lib/utils';

export type MediaTab = 'images' | 'videos';

interface MediaTabSwitcherProps {
  imageCount: number;
  onChange: (tab: MediaTab) => void;
  tab: MediaTab;
  videoCount: number;
}

const Tab = ({
  active,
  count,
  icon,
  label,
  onClick,
}: {
  active: boolean;
  count: number;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}) => (
  <button
    className={cn(
      'inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-bold transition-colors',
      active ? 'bg-brand-light text-brand-vivid' : 'text-text-muted hover:bg-action-ghost-hover'
    )}
    onClick={onClick}
    type="button"
  >
    {icon}
    {label}
    <span
      className={cn(
        'rounded-full px-2 py-0.5 text-xs',
        active ? 'bg-brand-vivid text-text-inverse' : 'bg-bg-surface-alt text-text-muted'
      )}
    >
      {count}
    </span>
  </button>
);

const MediaTabSwitcher = ({ imageCount, onChange, tab, videoCount }: MediaTabSwitcherProps) => (
  <div className="flex gap-3 px-5 py-3">
    <Tab
      active={tab === 'images'}
      count={imageCount}
      icon={<ImageIcon className="size-4" />}
      label="Imágenes"
      onClick={() => onChange('images')}
    />
    <Tab
      active={tab === 'videos'}
      count={videoCount}
      icon={<Video className="size-4" />}
      label="Videos"
      onClick={() => onChange('videos')}
    />
  </div>
);

export default MediaTabSwitcher;
